import { gql } from '@apollo/client';

export const fetchAvailableOfferingsForEntitlement = gql`
  query fetchAvailableOfferingsForEntitlement($id: String) {
    entitlementDetails(id: $id) {
      id
      edition
      plan
      transactionAccountId
      offering {
        id
        name
        level
        key
        sku
        productKey
        pricingType
        availableAddOns {
          offeringId
          name
        }
        availableSyntheticPricingPlans {
          type
          status
          discountPercentage
        }
      }
      addOns {
        nodes {
          offeringId
          name
          units
        }
      }
      availableOfferings {
        id
        name
        level
        key
        sku
        productKey
        pricingType
        status
        availableAddOns {
          offeringId
          name
        }
        availableSyntheticPricingPlans {
          type
          status
          discountPercentage
        }
      }
      validOfferings {
        key
        offeringKey
        offeringName
        status
      }
    }
  }
`;
